import React, { FC } from 'react';

import { DateOffsetInput } from '../../../../../generated/graphql';

import translate from '../../../../../i18n/translate';
import { getOffsetTitle } from '../../../../../utils/offset';
import ComposeMetaSection from '../../../../MUI/Compose/Meta/ComposeMetaSection';

type Props = {
  offset: DateOffsetInput | null;
};

/**
 * Section in the template compose that displays the offset
 *
 * @param props        Props passed to the component
 * @param props.offset Currently selected offset
 * @returns            The component itself
 */
const ComposeMetaOffset: FC<Props> = ({ offset }) => {
  const emptyOffsetLabel = translate('DUE_DATE__PLACEHOLDER');
  return (
    <ComposeMetaSection
      heading={offset === null ? emptyOffsetLabel : getOffsetTitle(offset)}
      icon="dueDate"
      isEmpty={offset === null}
    >
      {getOffsetTitle(offset)}
    </ComposeMetaSection>
  );
};

export default ComposeMetaOffset;
